module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "set-position",
    staticStyle: {
      "width": "100%",
      "max-width": "1200px",
      "margin": "0 auto"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "footer-right pull-right"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('p', [_vm._v("联系电话：" + _vm._s(_vm.telephone))]), _vm._v(" "), _c('p', [_vm._v("服务时间：" + _vm._s(_vm.servicetime))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "top",
      "width": "100px",
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/wechat.jpg",
      "alt": "",
      "width": "70px"
    }
  }), _vm._v(" "), _c('p', [_vm._v("友云采公众号")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "top",
      "width": "100px",
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/supplier.png",
      "alt": "",
      "width": "70px"
    }
  }), _vm._v(" "), _c('p', [_vm._v("供应商App")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "100px",
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/purchaser.png",
      "alt": "",
      "width": "70px"
    }
  }), _vm._v(" "), _c('p', [_vm._v("采购商App")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer-phone"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "static/imgs/footer-phone.png",
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_n2kyt3n4zhlb2wzyqixseugcou/~/vue-loader/lib/template-compiler?{"id":"data-v-77700991","hasScoped":false}!./~/.pnpm/vue-loader@12.2.2_n2kyt3n4zhlb2wzyqixseugcou/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/G-footer.vue
// module id = 38
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15